import type { IconSvgObject } from './types';

const ChartMinimumIcon: IconSvgObject = [
  ["path", { d: "M21 21H5C3.89543 21 3 20.1046 3 19V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 5C7 11.6274 9.68629 17 13 17C16.3137 17 19 11.6274 19 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartMinimumIcon;
